import React from 'react';
import { Grid, Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: `100vw`,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        overflow: `hidden`
    },
    copyRightText: {
        fontWeight: theme.typography.fontWeightLight,
        padding: theme.spacing(3),
        textAlign: "center",
    }
}));

export default function FooterLogo() {
    const classes =  useStyles();
    return (
        <Grid container direction="column" alignItems="center" className={classes.root} spacing={5}>
            <Grid item>
                <a href={process.env.REACT_APP_BAFTA_SITE} target="_blank" rel="noreferrer" style={{display: "table"}}>
                    <img src="/images/bafta-logo-footer.png" alt="Bafta logo in footer" style={{maxHeight: 60, objectFit: "contain"}} />
                </a>
            </Grid>
            <Grid item>
                <Typography variant={"subtitle1"} className={classes.copyRightText} component="div">
                    @ {new Date().getFullYear()}. BAFTA is a registered charity (no. 216726)
                </Typography>
            </Grid>
        </Grid>
    );
}